// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"x4-z"};